/* eslint semi: 1 */

import { PLAN_UPGRADE_STEPS } from './plan-upgrade-common';

export async function submitOverviewForm () {
  const { hasError, data } = await this.$refs.overview.submitForm();

  if (!hasError) {
    const { countryCode, countryName, state } = data;
    this.plan.setBillingCountryCode(countryCode);
    this.plan.setBillingCountry(countryName);
    this.plan.setBillingState(state);

    await this.switchPageAction(PLAN_UPGRADE_STEPS.STEP_BILLING_DETAILS);
  }
}

export async function submitBillingDetailsForm () {
  const { hasError, data } = await this.$refs.billingDetails.submitForm();

  if (!hasError) {
    this.plan.setBillingEmail(data.email);
    this.plan.setBillingCompanyName(data.companyName);
    this.plan.setBillingStreetAndNumber(data.streetAndNumber);
    this.plan.setBillingFirstname(data.firstName);
    this.plan.setBillingLastname(data.lastName);
    this.plan.setBillingCity(data.city);
    this.plan.setBillingPostalCode(data.zip);
    this.plan.setBillingEmail(data.email);
    this.plan.setBillingVAT(data.VAT);

    this.setPaymentData({});
    const { error } = await this.commitBillingDetails();
    // Early return if commitBillingDetails fails to
    // skip the next steps.
    if (error) return { error };

    await this.switchPageAction(PLAN_UPGRADE_STEPS.STEP_PAYMENT);
    await this.showDatatransLightbox();
    return { success: true };
  }
}

export async function handlePaymentForm () {
  if (this.payment.success) {
    this.$router.push('/menu');
    this.handleDialogClose();
    this.$utils.mainLoader(false);
    return;
  }

  // Try again
  if (this.payment.failed) {
    this.setPaymentData({});
    await this.reinitializePlan();
    await this.$router.push('/plans');
    await this.showDatatransLightbox();
    this.$utils.mainLoader(false);
  }
}
